export enum MuiButtonAppearanceEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger',
  INVERTED = 'inverted',
  GHOST = 'ghost',
  LINK = 'link'
}
